var FeaturesModule = (function () {
    function FeaturesModule() {
    }
    return FeaturesModule;
}());
export { FeaturesModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/features.module.ts.pre-build-optimizer.js